class SearchEngine {
    constructor(application, apiKey, index, options) {
        this.client = algoliasearch(application, apiKey);
        this.index = this.client.initIndex(index);
        this.facets = options.facets;
        this.results = options.results;
        this.template = options.template;
        this.postType = options.postType;
        this.pageSize = options.pageSize || 100;
        this.searchQuery = '';
        this._currentPage = 0;

        for(const facet of this.facets) {
            facet.bind(this);
        }

        this.update();
    }

    getGlobalFacetFilters() {
        let filters = '';

        if(this.postType) {
            filters += `type:"${this.postType}"`;
        }

        return filters;
    }

    async update() {
        // Reset page
        this._currentPage = 0;

        // Build facet query
        const facetFilters = this.facets.map(facet => facet.getFilter()).filter(x => x);

        const { hits } = await this.index.search(this.searchQuery, {
            filters: [ this.getGlobalFacetFilters(), ...facetFilters ].join(' AND '),
            page: this._currentPage,
            hitsPerPage: this.pageSize
        });

        const $children = hits.map(hit => this.template.render(hit));
        
        this.results.replaceChildren(...$children);

        this.onQueryChange && this.onQueryChange();
    }

    async loadMore() {
        // Build facet query
        const facetFilters = this.facets.map(facet => facet.getFilter()).filter(x => x);

        const { hits } = await this.index.search(this.searchQuery, {
            filters: [ this.getGlobalFacetFilters(), ...facetFilters ].join(' AND '),
            page: ++this._currentPage,
            hitsPerPage: this.pageSize
        });

        const $children = hits.map(hit => this.template.render(hit));

        this.results.append(...$children);

        return !!hits.length;
    }
}